import React from "react";
import { PropTypes } from "prop-types";
import { MrbButton, MrbFieldInput, MrbEditFormLayout } from "mrb/components";
import { PasswordFieldInfo } from "common/components";
import { defaultTemplate } from "common/hoc";
import { observer } from "mobx-react";

function LoadioConfigurationMasterPasswordEditTemplate({ loadioConfigurationViewStore, t }) {
    const { form } = loadioConfigurationViewStore;
    return (
        <React.Fragment>
            <div className="c-card c-card--primary c-membership__form">
                <h1 className="c-membership__form__title">
                    {t("ADMINISTRATION.LOADIO.CONFIGURATION.MASTER_PASSWORD_FORM_TITLE")}
                </h1>
                <MrbEditFormLayout
                    t={t}
                    form={form}
                    submitLabel="ADMINISTRATION.LOADIO.CONFIGURATION.BUTTONS.SAVE"
                    footer={<LoadioConfigurationMasterPasswordEditFooter form={form} t={t} />}
                >
                    <MrbFieldInput
                        classNameExtend="c-input--outline"
                        t={t}
                        field={form.$("currentPassword")}
                        autoComplete="current-password"
                    />
                    <PasswordFieldInfo field={form.$("newPassword")} />
                    <MrbFieldInput
                        classNameExtend="c-input--outline"
                        t={t}
                        field={form.$("newPassword")}
                        autoComplete="new-password"
                    />
                    <MrbFieldInput
                        classNameExtend="c-input--outline"
                        t={t}
                        field={form.$("confirmNewPassword")}
                        autoComplete="confirm-new-password"
                    />
                </MrbEditFormLayout>
            </div>
        </React.Fragment>
    );
}

LoadioConfigurationMasterPasswordEditTemplate.propTypes = {
    loadioConfigurationViewStore: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
};

const LoadioConfigurationMasterPasswordEditFooter = observer(function LoadioConfigurationMasterPasswordEditFooter({
    form,
    t,
}) {
    const label = t("ADMINISTRATION.LOADIO.CONFIGURATION.BUTTONS.SAVE");
    return (
        <div className="c-form__footer">
            <MrbButton
                type="submit"
                aria-label={label}
                aria-busy={form.submitting || form.validating}
                label={label}
                className="c-btn c-btn--primary c-btn--med u-width--100"
            />
        </div>
    );
});

export default defaultTemplate(LoadioConfigurationMasterPasswordEditTemplate);
